<template>
  <div class="homeIndexGoodBusiness HomeContainer">
    <div class="title">
      <img :src="GetResourceUrl('index/icon-good_business.png')" />
      <span>{{l("优选好商")}}</span>
      <router-link class="more" to="/home/good_business">{{l("更多")}}>></router-link>
    </div>
    <div class="companyContainer">
      <div v-for="item of companyList" :key="item.id" class="companyItem">
        <el-image :src="item.logo" fit="contain" class="logo"></el-image>
        <div class="cover">
          <div class="name one_lines">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeIndexGoodBusiness",
  data() {
    return {
      companyList: [],
    };
  },
  created() {
    this.getArticleList();
  },
  methods: {
    getArticleList() {
      this.axios
        .get("/api/good_business/", {
          params: {
            size: 12,
            page: 1,
          },
        })
        .then((data) => {
          this.companyList = data.results;
        });
    },
  },
};
</script>


<style scoped lang="scss">
.homeIndexGoodBusiness {
  margin-top: 20px;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: flex-end;
    width: 100%;
    img {
      margin-right: 15px;
      width: 32px;
      height: 32px;
    }
    span {
      font-weight: bold;
      font-size: 20px;
    }
    .more {
      margin-left: auto;
      font-size: 12px;
      color: $warningColor;
    }
  }
  .companyContainer {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    outline: 1px solid $borderPlainColor;
    .companyItem {
      width: 190px;
      height: 88px;
      box-sizing: border-box;
      border-right: 1px solid $borderPlainColor;
      position: relative;
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6) {
        border-bottom: 1px solid $borderPlainColor;
      }
      &:nth-child(6),
      &:nth-child(12) {
        border-right: none;
      }
      .logo {
        width: 120px;
        height: 60px;
        margin-left: 35px;
        margin-top: 14px;
      }
      .cover {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.75);
        color: #fff;
        box-sizing: border-box;
        padding: 0 12px;
        .name {
          text-align: center;
          font-size: 15px;
          line-height: 88px;
        }
      }
      &:hover {
        .cover {
          display: block;
        }
      }
    }
  }
}
</style>

